import React, { FC } from 'react';
import { Progress } from 'antd';

import { formatSize } from './helpers';

import { UploadItemProps } from './types';

import { FileSize, FileError } from './styled';

const UploadFooterContent: FC<Pick<UploadItemProps, 'file' | 'listType'>> = ({
  file,
  listType,
}) => {
  if (file.status && file.status !== 'error' && listType !== 'text') {
    return <Progress percent={file.percent} size='small' />;
  }

  if (listType !== 'text' && !file.status && file.size && file.size > 0) {
    return <FileSize>{formatSize(file.size)}</FileSize>;
  }

  if (file.error) {
    const errorMessage = typeof file.error === 'string' ? file.error : 'Ошибка при загрузке файла';
    return <FileError>{errorMessage}</FileError>;
  }

  return null;
};

export default UploadFooterContent;
